export const Bio = {
  name: "Siva Satyanarayana",
  roles: [
    "Java Full Stack Developer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/shivasatya",
  resume:
    "https://drive.google.com/file/d/17iIC4PBAmvis4Rcw8bwDVV2i_Ffc-gLj/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/siva-satyanarayana-madala-137693261/",
  insta: "https://www.instagram.com/madhaleshiva/",
  facebook: "https://www.facebook.com/people/Shiva-Chowdary/pfbid037e4wBWJq7DNkM96P4a8nsfPCi8WEzYC98aJsRPsuyouGromZC9QAGC1g8ghLpDqcl/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
    
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://w7.pngwing.com/pngs/279/249/png-transparent-java-logo-programming-language-java-plum-miscellaneous-text-orange-thumbnail.png",
      },
      {
        name: "Spring Boot",
        image:
          "https://www.yessinfotech.com/wp-content/uploads/2019/11/spring-boot-logo.png",
      },
      {
        name: "Microservices",
        image:
          "https://w1.pngwing.com/pngs/535/256/png-transparent-microservices-text-computer-software-line-circle-area-diagram-symmetry-organization-thumbnail.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://cdn.cookielaw.org/logos/70564414-548a-4286-8ad7-04d95b172a08/e26443c0-68d1-47c8-b8fc-9bc765da2e95/3a159462-db70-43cf-a27d-f602a6baed44/pm-logo-horiz.png",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkJhtEZSioz5EyK4L0uLUk924PRql_W3lopg&s",
    role: "Java Developer",
    company: "Autorox  Pvt. Ltd.",
    date: "june 2022- November 2022",
    desc: "Working on the Backend of the web application using java,Spring Boot,microservices",
    skills: [
      "JAVA",
      "Docker",
      "Spring Boot",
      "Microservices", 
      "SQL DB",
      "NO SQL DB"
    ],
  },
  {
    id: 1,
    img: "https://static.vecteezy.com/system/resources/thumbnails/007/252/639/small/labor-law-lawyer-legal-business-internet-technology-concept-photo.jpg",
    role: "Java full stack developer",
    company: "LegalE Innovation Private Limited",
    date: "April 2023 ",
    desc: "Working on the Backend and frontend of the web application using java,Spring Boot,microservices ReactJS, and Redux ",
    skills: [
      "JAVA",
      "Docker",
      "Spring Boot",
      "Microservices",
      "ReactJS",
      "Redux",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://static.wixstatic.com/media/2faa6d_acc04fb02882461e906fc55049768b40~mv2.png/v1/fill/w_241,h_315,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/SWARNA%20BHARATH%2C%20Khammam%2C%20LOGO.png",
    school: "Swarna Bharathi Institute of Science and Technology, Khammam",
    date: "August 2017 - December 2021",
    grade: "6.74 CGPA",
    desc: " I am currently pursuing a Bachelor's degree in Mechanical and Engineering at Swarna Bharathi Institute of Science and Technology, Khammam. I have completed 4 semesters and have a CGPA of 6.74. ",
    degree: "Bachelor of Technology - BTech, Mechanical  Engineering",
  },
  {
    id: 1,
    img: "https://scontent.fhyd2-2.fna.fbcdn.net/v/t39.30808-6/301904927_368857978789956_357734707682879980_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=vO7XxX9WWS4Q7kNvgFU2f6L&_nc_ht=scontent.fhyd2-2.fna&_nc_gid=AumUNwscBlPyrDpD6fMRAc-&oh=00_AYDYjR13rzTN3sKimHdWYE5MNlcUpyaRf2v_imNXSbj1bQ&oe=66FB13E0",
    InterCollege: "Sri chaitanya junior college ,Khammam",
    date: "june 2015 - july 2017",
    grade: "74%",
    desc: "I completed my class 12 high school education at Sri chaitanya junior College, Khammam, where I studied MPC.",
    degree: "Inter(XII), MPC",
  },
  {
    id: 2,
    img: "https://pngimagesfree.com/wp-content/uploads/swami-vivekananda-png-images-1.png",
    school: "Sri Vivekananda Vidyalayam, moddulagudem",
    date: "Apr 2004 - MAy 2015",
    grade: "83.3%",
    desc: "I completed my class 10 education at Sri Vivekananda Vidyalayam, moddulagudem, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "Employee management",
    date: "December 2023 - March 2023",
    description:
      "Employee management software streamlines processes like performance tracking, payroll, and communication, enhancing efficiency and organization. It helps managers focus on core objectives while supporting employee engagement and development.",
    image:
      "https://e7.pngegg.com/pngimages/553/134/png-clipart-employee-engagement-human-resource-management-organization-teamwork-miscellaneous-company.png",
    tags: [
      "Docker",
      "Java",
      "Spring Boot",
      "microservices",
      "Spring Security",
      "React Js",
      "My SQL",
    
    ],
    category: "Employee management",
    github: "https://github.com/shivasatya/admin.git",
  },
 
];

export const TimeLineData = [
  { year: 2021, text: "Started my journey" },
  { year: 2022, text: "Worked as a  freelance developer for few months " },
  { year: 2022, text: "My first job was at Autorox Software Company." },
  { year: 2023, text: "I shifted my job to LegalE Innovation Private Limited, a software company." },
  { year: 2024, text: "Currently, I am working at LegalE Innovation Private Limited, a software company. " },
];
